document.addEventListener('DOMContentLoaded', () => {
  const headings = document.querySelectorAll('.footer-block__heading:not(.no-accordion-mobile)');
  const mq = window.matchMedia('(max-width: 749px)');

  const isMobile = () => mq.matches;

  const animate = (el, expand) => {
    el.style.display = 'block';

    const startHeight = expand ? 0 : el.scrollHeight;
    const endHeight = expand ? el.scrollHeight : 0;

    el.style.height = startHeight + 'px';
    el.style.opacity = expand ? '0' : '1';

    requestAnimationFrame(() => {
      el.style.transition = 'height 300ms ease, opacity 300ms ease';
      el.style.height = endHeight + 'px';
      el.style.opacity = expand ? '1' : '0';
    });

    const onEnd = () => {
      el.style.transition = '';
      if (expand) {
        el.style.height = 'auto';
      } else {
        el.style.display = 'none';
      }
      el.removeEventListener('transitionend', onEnd);
    };

    el.addEventListener('transitionend', onEnd);
  };

  const closeAll = (except) => {
    headings.forEach(h => {
      if (h !== except && h.classList.contains('active')) {
        h.classList.remove('active');
        animate(h.nextElementSibling, false);
      }
    });
  };

  const reset = () => {
    headings.forEach((h, i) => {
      const content = h.nextElementSibling;

      if (isMobile()) {
        h.classList.remove('active');
        content.style.display = 'none';
        content.style.height = '0px';
        content.style.opacity = '0';
      } else {
        h.classList.remove('active');
        content.style.display = '';
        content.style.height = '';
        content.style.opacity = '';
      }
    });

    // ⭐ first open
    if (isMobile() && headings.length) {
      const first = headings[0];
      const content = first.nextElementSibling;

      first.classList.add('active');
      content.style.display = 'block';
      content.style.height = 'auto';
      content.style.opacity = '1';
    }
  };

  reset();
  mq.addEventListener('change', reset);

  headings.forEach(heading => {
    heading.addEventListener('click', () => {
      if (!isMobile()) return;

      const content = heading.nextElementSibling;
      const isActive = heading.classList.contains('active');

      closeAll(heading);

      if (isActive) {
        heading.classList.remove('active');
        animate(content, false);
      } else {
        heading.classList.add('active');
        animate(content, true);
      }
    });
  });
});